var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.418 9.417h1.167v-3.5H5.418v3.5zm.583-4.667a.565.565 0 0 0 .416-.168.562.562 0 0 0 .168-.415.565.565 0 0 0-.168-.416A.562.562 0 0 0 6 3.583a.565.565 0 0 0-.416.168.562.562 0 0 0-.167.416c0 .165.056.304.168.416.112.112.25.167.415.167zm0 7.583a5.676 5.676 0 0 1-2.275-.46 5.898 5.898 0 0 1-1.852-1.246A5.887 5.887 0 0 1 .628 8.775 5.69 5.69 0 0 1 .168 6.5c0-.807.153-1.565.46-2.275a5.9 5.9 0 0 1 1.246-1.852 5.887 5.887 0 0 1 1.852-1.247 5.69 5.69 0 0 1 2.275-.46c.807 0 1.566.154 2.275.46a5.9 5.9 0 0 1 1.852 1.247c.525.525.941 1.142 1.248 1.852.306.71.459 1.468.459 2.275 0 .807-.154 1.565-.46 2.275a5.9 5.9 0 0 1-1.247 1.852 5.894 5.894 0 0 1-1.852 1.247c-.71.307-1.468.46-2.275.46z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInformation);
export default __webpack_public_path__ + "static/media/white-information.11d35ed2498841b4f8c37e213f3a6180.svg";
export { ForwardRef as ReactComponent };